function t() {
  return window.zxcvbn ? Promise.resolve() : new Promise((e, r) => {
    const n = document.createElement("script");
    n.type = "text/javascript", n.async = !0, n.src = "https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js", n.integrity = "sha256-Znf8FdJF85f1LV0JmPOob5qudSrns8pLPZ6qkd/+F0o=", n.crossOrigin = "anonymous", n.onload = e, n.onerror = r, document.getElementsByTagName("head")[0].appendChild(n);
  });
}
function o(e) {
  return t().then(() => e ? window.zxcvbn(e) : 0);
}
export {
  o as checkPasswordStrength
};
//# sourceMappingURL=password-strength.js.map
